import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { IBoton } from 'modelos/src';

/**
 * Tab "Monitoreo / Integraciones": config de la app de monitoreo,
 * eventos externos (RF/BLE) y las integraciones SOFLEX e IRIX.
 * Recibe el formulario raíz por referencia: edita los mismos controles.
 */
@Component({
  selector: 'app-tab-monitoreo-integraciones',
  templateUrl: './tab-monitoreo-integraciones.component.html',
  styleUrls: ['./tab-monitoreo-integraciones.component.scss'],
  standalone: false,
})
export class TabMonitoreoIntegracionesComponent {
  @Input() public formulario?: UntypedFormGroup;
  @Input() public botones: IBoton[] = [];
  /** Los eventos externos/BLE asocian botones del cliente: ocultos en el wizard de creación. */
  @Input() public mostrarEventos = true;

  get configuracion(): UntypedFormGroup {
    return this.formulario?.get('configuracion') as UntypedFormGroup;
  }

  get configSOFLEX(): UntypedFormGroup {
    return this.configuracion?.get('configSOFLEX') as UntypedFormGroup;
  }

  get integracionSOFLEX(): boolean {
    return this.configuracion?.get('integracionSOFLEX')?.value;
  }

  get configIRIX(): UntypedFormGroup {
    return this.configuracion?.get('configIRIX') as UntypedFormGroup;
  }

  get integracionIRIX(): boolean {
    return this.configuracion?.get('integracionIRIX')?.value;
  }
}
